<template>
  <v-container fluid>
    <v-row class="mb-0">
      <v-col>
        <h1>Неуточненные диагнозы пациента</h1>
      </v-col>

      <v-col align="right">
        <Modal component="add-symptom" depressed icon="add" name="Неуточненный диагноз" title="Добавить неуточненный диагноз" />
      </v-col>
    </v-row>

    <patient-header />
    <symptoms-list />
  </v-container>
</template>

<script>
import SymptomsList from "@/views/pages/diagnosis/components/SymptomsList";
import Modal from "@/components/Modal";

import PatientHeader from "@/components/PatientHeader";
export default {
  components: {
    Modal,
    SymptomsList,
    PatientHeader,
  },
};
</script>

<style></style>
